module.exports = __webpack_public_path__ + "static/media/rock.77b80378.png";